{
  "el": {
    "building": {
      "attributes": {
        "description": "Περιγραφή",
        "elevators": "Αριθμός ανελκυστήρων",
        "end_date": "Ημερομηνία λήξης",
        "floors": "Αριθμός ορόφων",
        "internal_note": "Εσωτερική σημείωση κτιρίου",
        "name": "Όνομα",
        "start_date": "Ημερομηνία έναρξης",
        "surface_shared": "Επιφάνεια κοινόχρηστων χώρων"
      },
      "labels": {
        "building": "Κανένα κτίριο | Ένα κτίριο | {count} κτίρια"
      },
      "toasts": {
        "create": "Το κτίριο δημιουργήθηκε",
        "delete": "Το κτίριο διαγράφηκε",
        "update": "Το κτίριο ενημερώθηκε"
      },
      "validation": {
        "needName": "Ο τίτλος είναι υποχρεωτικός",
        "needNumber": "Πρέπει να είναι αριθμός (π.χ. 85)"
      }
    }
  }
}
